import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';
import { ajax } from 'rxjs/ajax';

export const parentDashboardService = {
  getCarerStudents,
  getPlotCourses,
  getPlotTask,
  getStudentAcademicRepots,
  getStudentAbsenceSummary,
  getLearningBehaviour,
  getLearningGoals,
  getHomeRoomComments,
  getStudentList,
  getStudentNotes,
  sendNotes,
  getLearningBehaviourByCourse,
};


function getCarerStudents(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.students + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('getCarerStudents', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          if (console.error.responceObject) {
            observer.error(error.responceObject.userMessage);
          }
        }
      });
  });
}

function getStudentList(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.students + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('getStudentList', result);
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.message);
        }
      });
  });
}

function getStudentNotes(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.studentnotes + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.message);
        }
      });
  });
}

function sendNotes(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.studentnotes, {
      method: 'POST',
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getLearningBehaviourByCourse(payload) {
  const param = new URLSearchParams();
  param.append('username', payload.username);
  // return ajax({
  //   url: config.by_course + `?${param.toString()}`,
  //   method: 'GET',
  //   mode: 'no-cors',
  //   headers: {
  //     Authorization: payload.token,
  //   },
  // });
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.learningBehaviourByBourse + `?${param.toString()}`, {
      method: 'GET',
      headers: {
        Authorization: payload.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.message);
        }
      });
  });
}

function getPlotCourses(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.student_plot_course + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getPlotTask(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.student_plot_task + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getStudentAcademicRepots(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.student_academic_report + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getStudentAbsenceSummary(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.student_absence_summary + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getLearningBehaviour(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.learning_behaviour + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getLearningGoals(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.learning_goals + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function getHomeRoomComments(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.homeroom_comments + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}
